const navigationSettings = {
  showExpandedCart: true,
};

export default navigationSettings;
